export default "__VITE_ASSET__CYNLsvWK__"